import type { SupportedLanguage } from '@ooh/screens';

export type { SupportedLanguage };

const STORAGE_KEY = 'ooh:lang';

/** Returns the persisted language preference, or `'pl'` when absent, malformed, or unreadable. */
export function readStoredLanguage(storage?: Storage): SupportedLanguage {
  try {
    const raw = (storage ?? window.localStorage).getItem(STORAGE_KEY);
    return raw === 'pl' || raw === 'en' ? raw : 'pl';
  } catch {
    return 'pl';
  }
}

export function writeStoredLanguage(lng: SupportedLanguage, storage?: Storage): void {
  try {
    (storage ?? window.localStorage).setItem(STORAGE_KEY, lng);
  } catch {
    // Storage unavailable (private mode, quota) — language still changes for this session.
  }
}
